import styled from 'styled-components';

export const StyledButtonContainer = styled.div<{ isSelected: boolean }>`
  display: flex;
  border-radius: 8px;
  padding: ${props => (props.isSelected ? '15px' : '16px')};
  ${props =>
    props.isSelected
      ? 'border: 2px solid var(--border-primary); background: var(--surface-secondary);'
      : 'border: 1px solid var(--border-primary);'}
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
